import SchoolIcon from '@mui/icons-material/School';

import { Metadata } from '../../../learning-content';

export default function PathCertification({
  translations = {
    accessibilityLabel: 'Diploma',
  },
  ...props
}) {
  return (
    <Metadata
      accessibilityLabel={translations.accessibilityLabel}
      shouldNotWrap
      icon={SchoolIcon}
      {...props}
    />
  );
}
